export default "__VITE_ASSET__DJeDkaeb__"